<template>
    <div>
        <paid-modal v-if="!is_paid" hot-key/>
        <title>{{ $t('customcolor.text_1') }} - DOFFERO®</title>
        <div class="title">
            <under-bar-name :title="$t('customcolor.text_2')" :margin="false"></under-bar-name>
        </div>
        <div class="cont">
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x" crossorigin="anonymous">
            <h1>{{ $t('customcolor.text_3') }}</h1>
            <h3>{{ $t('customcolor.text_4') }}</h3>
            <div class="main">
                <color-picker class="color_picker" :offercolor="offercolor" v-on:getColor="color = $event"/>
                <div v-if="is_paid" class="ulozit" @click="save">
                    <span v-show="!saved">{{ $t('customcolor.text_5') }}</span>
                    <div v-show="saved" class=" lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>


<script>
import UnderBarName from '../../../layouts/Header/UnderBarName.vue'
import ColorPicker from './components/ColorPicker.vue'  
import PaidModal from '../../vue_components/PaidModal.vue'
    export default {
        props: ['offercolor', 'is_paid'],
        components: { ColorPicker, UnderBarName, PaidModal },
        data() {
            return {
                saved: false,
                color: "#F3385A"
            }
        },
        methods: {
            save() {
                this.saved = true
                axios
                .post(`/api/premium/saveColor`, {'color': this.color})
                .then(response => {
                    setTimeout(() => {
                        this.saved = false
                        this.$toast.success(this.$t('customcolor.text_9'), { timeout: 2038,  });
                    }, 1000);
                })
                .catch(errors => {});
            },
        },
    }
</script>

<style lang="scss" scoped>
.color_picker{
    width: 477px;
    margin: 0 auto;
    @media only screen and (max-width: 600px) {
            width: 95%;
    }
}
.lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }
    .lds-ellipsis div {
        position: absolute;
        top: 33px;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background: #fff;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(24px, 0);
        }
    }   
    .title{
       width: 1188px;
       margin: 65px auto 0 auto;
       @media only screen and (max-width: 1500px) {
            width: 95%;
        }
    }
    .cont{
        width: 1188px;
        margin: 50px auto 0 auto;
        background: #FFFFFF;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        padding: 57px 0 140px 0;
        @media only screen and (max-width: 1500px) {
            width: 95%;
        }
        h1{
            @media only screen and (max-width: 600px) {
                width: 90%;
                margin: 0 auto;
            }
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 36px;
            line-height: 42px;
            text-align: center;
            color: #2e0808;
        }
        h3{
            width: 741px;
            @media only screen and (max-width: 600px) {
                width: 90%;
            }
            margin: 23px auto 36px auto;
            font-family: Roboto;
            font-style: normal;
            font-weight: 500;
            font-size: 24px;
            line-height: 36px;
            text-align: center;
            color: #9598A7;
        }
        .main{
            width: 1030px;
            margin: 0 auto;
            background: #F2F7FB;
            border-radius: 5px;
            padding: 50px 0 78px 0;
            @media only screen and (max-width: 1500px) {
                width: 90%;
            }
            .ulozit{
                width: 474px;
                height: 55px;
                @media only screen and (max-width: 600px) {
                    width: 95%;
                }
                margin: 47px auto 0 auto;
                background: #2ED8B6;
                border-radius: 4px;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 16px;
                line-height: 19px;
                display: flex;
                align-items: center;
                text-align: center;
                justify-content: center;
                color: #FFFFFF;
                cursor: pointer;
                transition: .5s all;
                &:hover{
                    background: #23caa9;
                }
            }
        }
    }
</style>